"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment FiftyBanner on EditorialFiftyBanner {\n    __typename\n    editorialContentType\n    backgroundImage {\n      __typename\n      url\n      urlMobile\n    }\n    backgroundVideo {\n      __typename\n      id\n      autoplayOnScroll\n      playInLoop\n      type\n    }\n    backgroundType\n    contentAlignment\n    id\n    title\n    link {\n      __typename\n      id\n      relativeUrl\n      title\n      type\n      appLink {\n        __typename\n        link\n        deepLink\n      }\n    }\n    storybookColor\n    steps {\n      __typename\n      caption\n      content {\n        __typename\n        text\n        textLinks {\n          __typename\n          relativeUrl\n          title\n          type\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fiftyModuleFragment = void 0;
var _fetching = require("@ori/fetching");
const fiftyModuleFragment = exports.fiftyModuleFragment = (0, _fetching.gql)(_templateObject());
